<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import axios from 'axios';
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales Analysis Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      total_amount: 0,
      total_paid: 0,
      total_discount: 0,
      total_balance: 0,
      returnData: {
        sale_id: '',
        product_id: '',
        product_name: '',
        quantity: '',
        unit_price: '',
        batch: '',
        date: moment(new Date()).format("YYYY-MM-DD"),
        reason: '',
        mode: '',
        type: 0,
        filterSales: {
          datefrom: moment(new Date()).format("YYYY-MM-DD"),
          dateto: moment(new Date()).format("YYYY-MM-DD"),
          product: '',
          branch_id: 0
        },
      },
      pickData: {
        sale_id: '',
        product_id: '',
        product_name: '',
        quantity: '',
        batch: '',
        date: moment(new Date()).format("YYYY-MM-DD"),
        type: 0,
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Sales Analysis Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Analysis Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      ReturnedSales: [],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: 'DETAILS',
        },
        {
          key: "customerobj.name",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "totalAmt",
          sortable: true,
          label: 'TOTAL',
        },
        {
          key: "totalPaid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "addedon",
          sortable: true,
          label: "DATE",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTIONS",
        }
      ],
      businessfields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: 'DETAILS',
        },
        {
          key: "customerobj.name",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "totalAmt",
          sortable: true,
          label: 'TOTAL',
        },
        {
          key: "totalPaid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "addedon",
          sortable: true,
          label: "DATE",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTIONS",
        }
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("sales", ["SalesAnalysis", "SaleSaveStatus", "SalesReturn", "filterStatus"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings", "ReceiptSettings"]),
    ...mapGetters("auth", ["business", "branch", "Branches", "branchid"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.SalesAnalysis ? this.SalesAnalysis.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.SalesAnalysis ? this.SalesAnalysis.length : 1;
  },
  methods: {
    ...mapActions({
      FetchProducts: "products/fetchProducts",
      FetchSales: "sales/fetchSales",
      FetchReturns: "sales/fetchReturns",
      SaveReturn: "sales/returnSale",
      SavePick: "sales/pickSale",
      FetchModes: "setting/fetchPaymentOptions",
      FetchBranches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      fetchReceiptSettings: "setting/fetchReceiptSettings",


    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Excel_export() {
      axios
        .post("export_sales", this.returnData.filterSales, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    SalesReportData() {
      this.FetchSales(this.returnData.filterSales);
    },
    Receipt_print(Id) {
      if (this.ReceiptSettings.receipt_type == 1) {
        window.open(
          `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(Id)}`
        );
      } else if (this.ReceiptSettings.receipt_type == 2) {
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv2.php?id=${btoa(Id)}`
        );
      } else if (this.ReceiptSettings.receipt_type == 3) {
        window.open(
          `https://${window.location.host}/receipts/salesreceiptv3.php?id=${btoa(Id)}`
        );
      } else {
        window.open(
          `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(Id)}`
        );
      }
    },
    Showreturn_modal(data) {
      this.returnData.sale_id = data.saleId;
      this.returnData.product_id = data.product_id;
      this.returnData.product_name = data.product;
      this.returnData.unit_price = data.SPrice;
      this.returnData.batch = data.batch;
    },
    Showpick_modal(data) {
      this.pickData.sale_id = data.saleId;
      this.pickData.product_name = data.product;
      this.pickData.batch = data.batch;
    },
    resetSave() {
      // this.resetErrors();
      this.returnData.sale_id = '';
      this.returnData.product_id = '';
      this.returnData.product_name = '';
      this.returnData.quantity = '';
      this.returnData.unit_price = '';
      this.returnData.batch = '';
      this.returnData.reason = '';
      this.returnData.date = moment(new Date()).format("YYYY-MM-DD");
      this.modal_id = "";
    },
    Return_sale() {
      this.SaveReturn(this.returnData);
      this.closeModal('return-sale-modal');
    },
    Pick_sale() {
      this.SavePick(this.pickData);
      this.closeModal('pick-item-modal');
    },
    resetPickItem() {
      this.pickData.id = '';
      this.pickData.sale_id = '';
      this.pickData.product_name = '';
      this.pickData.date = moment(new Date()).format("YYYY-MM-DD");
      this.modal_id = "";
    },
  },
  updated() {
    let total_amount = 0;
    let total_paid = 0;
    let total_discount = 0;
    let total_balance = 0;
    if (this.SalesAnalysis) {
      this.SalesAnalysis.forEach((item) => {
        total_amount = total_amount + parseInt(item.totalAmt);
        total_paid = total_paid + parseInt(item.totalPaid);
        total_discount = total_discount + parseInt(item.discount);
        total_balance = total_balance + parseInt(item.balance);
      });
      this.total_amount = total_amount;
      this.total_paid = total_paid;
      this.total_discount = total_discount;
      this.total_balance = total_balance;
    }
  },
  watch: {
    Sales(newValue) {
      if (newValue == true) {
        this.SalesReportData();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetError();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.FetchProducts();
    this.FetchBranches();
    this.FetchSales(this.returnData.filterSales);
    this.FetchModes();
    this.FetchReturns();
    this.FetchGeneralSettings();
    this.fetchReceiptSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Sales Analysis Report from {{ returnData.filterSales.datefrom }}
                  to {{ returnData.filterSales.dateto }}</h3>
              </div>

            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="returnData.filterSales.branch_id"
                  option-value="id" option-text="name" placeholder="Select Branch" @input="SalesReportData()">
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"><i class="fa fa-file-excel"></i>Export</b-button>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input type="date" v-model="returnData.filterSales.datefrom" class="form-control" />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input v-model="returnData.filterSales.dateto" type="date" class="form-control" />
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>

                <model-list-select :list="Products ? Products : []" v-model="returnData.filterSales.product"
                  option-value="id" option-text="name" placeholder="Select Product" @input="SalesReportData()">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="SalesReportData()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table v-if="BranchData.BranchId == 0" class="datatables" :items="SalesAnalysis ? SalesAnalysis : []"
                :fields="businessfields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(totalAmt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(totalPaid)="data">
                  {{ thousandSeperator(data.item.totalPaid) }}
                </template>
                <template #cell(discount)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(balance)="data">
                  {{ thousandSeperator(data.item.balance) }}
                </template>
                <template #cell(actions)="data">
                  <b-button variant="info" @click="Receipt_print(data.item.id)">Reprint</b-button>
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <thead v-if="data.index == 0">
                      <tr>
                        <th width="50%">Item</th>
                        <th width="10%">Qty</th>
                        <th width="15%">Price</th>
                        <th width="15%">Total</th>
                        <th v-if="GeneralSettings.sale_description != 1 && BranchData.BranchId != 0" width="10%">Return
                        </th>
                        <th v-else width="10%">Pick</th>
                        <th v-if="GeneralSettings.sale_description == 1 && BranchData.BranchId != 0" width="10%">Date
                          Picked</th>
                      </tr>
                    </thead>
                    <thead v-else></thead>
                    <tbody>
                      <tr v-for="(sale, s) in data.item.items" :key="s">
                        <td width="50%">{{ sale.product }}</td>
                        <td width="10%">{{ sale.qty }}</td>
                        <td width="15%">{{ thousandSeperator(sale.SPrice) }}</td>
                        <td width="15%">
                          {{ thousandSeperator(sale.SPrice * sale.qty) }}
                        </td>
                        <td>
                          <b-button
                            v-if="GeneralSettings.sale_description != 1 && sale.Returned == 1 && BranchData.BranchId != 0"
                            variant="secondary" disabled>Returned</b-button>
                          <b-button
                            v-if="GeneralSettings.sale_description != 1 && sale.Returned != 1 && BranchData.BranchId != 0"
                            v-b-modal.return-sale-modal @click="Showreturn_modal(sale)"
                            variant="primary">Return</b-button>
                          <b-button
                            v-if="GeneralSettings.sale_description == 1 && sale.Picked == 1 && BranchData.BranchId != 0"
                            variant="secondary" disabled>Picked</b-button>
                          <b-button
                            v-if="GeneralSettings.sale_description == 1 && sale.Picked != 1 && BranchData.BranchId != 0"
                            v-b-modal.pick-item-modal @click="Showpick_modal(sale)" variant="primary">Mark
                            Picked</b-button>
                        </td>
                        <td v-if="GeneralSettings.sale_description == 1 && sale.DatePicked != ''">
                          {{ sale.DatePicked }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
              <b-table v-else class="datatables" :items="SalesAnalysis ? SalesAnalysis : []" :fields="fields"
                responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(totalAmt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(totalPaid)="data">
                  {{ thousandSeperator(data.item.totalPaid) }}
                </template>
                <template #cell(discount)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(balance)="data">
                  {{ thousandSeperator(data.item.balance) }}
                </template>
                <template #cell(actions)="data">
                  <b-button variant="info" @click="Receipt_print(data.item.id)">Reprint</b-button>
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <thead v-if="data.index == 0">
                      <tr>
                        <th width="50%">Item</th>
                        <th width="10%">Qty</th>
                        <th width="15%">Price</th>
                        <th width="15%">Total</th>
                        <th v-if="GeneralSettings.sale_description != 1" width="10%">Return</th>
                        <th v-else width="10%">Pick</th>
                        <th v-if="GeneralSettings.sale_description == 1" width="10%">Date Picked</th>
                      </tr>
                    </thead>
                    <thead v-else></thead>
                    <tbody>
                      <tr v-for="(sale, s) in data.item.items" :key="s">
                        <td width="50%">{{ sale.product }}</td>
                        <td width="10%">{{ sale.qty }}</td>
                        <td width="15%">{{ thousandSeperator(sale.SPrice) }}</td>
                        <td width="15%">
                          {{ thousandSeperator(sale.SPrice * sale.qty) }}
                        </td>
                        <td>
                          <b-button v-if="GeneralSettings.sale_description != 1 && sale.Returned == 1"
                            variant="secondary" disabled>Returned</b-button>
                          <b-button v-if="GeneralSettings.sale_description != 1 && sale.Returned != 1"
                            v-b-modal.return-sale-modal @click="Showreturn_modal(sale)"
                            variant="primary">Return</b-button>
                          <b-button v-if="GeneralSettings.sale_description == 1 && sale.Picked == 1" variant="secondary"
                            disabled>Picked</b-button>
                          <b-button v-if="GeneralSettings.sale_description == 1 && sale.Picked != 1"
                            v-b-modal.pick-item-modal @click="Showpick_modal(sale)" variant="primary">Mark
                            Picked</b-button>
                        </td>
                        <td v-if="GeneralSettings.sale_description == 1 && sale.DatePicked != ''">
                          {{ sale.DatePicked }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>

              <!--Mark picked modal starts -->
              <b-modal id="pick-item-modal" hide-footer @hidden="resetPickItem" class="text-danger">
                <template #modal-title> Mark item {{ pickData.product_name }} picked</template>
                <div class="form-group mb-3">
                  <div class="input-group">
                    <h5>Do you want to mark these items picked? Click Proceed to continue.</h5>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Pick Date</label>
                  <div class="input-group">
                    <input type="date" placeholder="Enter Date" class="form-control" v-model="pickData.date" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="closeModal('pick-item-modal')">
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-danger" @click="Pick_sale('pick-item-modal')">
                    <i class="fa fa-circle-check"></i> Proceed
                    <b-spinner v-if="SaleSaveStatus" variant="light" small label="Picking"></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- Mark picked modal ends -->
              <!-- modal starts -->
              <b-modal id="return-sale-modal" hide-footer @hidden="resetSave">
                <template #modal-title> Return New Item </template>
                <div class="form-group mb-3">
                  <label>Product Name</label>
                  <div class="input-group">
                    <input type="text" placeholder="Enter product" class="form-control"
                      v-model="returnData.product_name" />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Return Date</label>
                  <div class="input-group">
                    <input type="date" placeholder="Enter Date" class="form-control" v-model="returnData.date" />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Quantity</label>
                  <div class="input-group">
                    <input type="number" placeholder="Enter quantity" class="form-control"
                      v-model="returnData.quantity" />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Reason</label>
                  <div class="input-group">
                    <textarea type="text" placeholder="Enter reason" class="form-control"
                      v-model="returnData.reason"></textarea>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label>Payment Option</label>
                  <div class="input-group">
                    <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="returnData.mode"
                      option-value="id" option-text="mode" placeholder="Select Mode">
                    </model-list-select>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" data-dismiss="modal"
                    @click="closeModal('return-sale-modal')">
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-primary" @click="Return_sale()"> <i class="fa fa-check"></i>
                    Submit
                    <b-spinner v-if="SaleSaveStatus" variant="light" small label="Spinning"></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
              <div class="row">
                <div class="col-md-3">
                  <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(total_amount) }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Paid: <span class="text-danger">{{ thousandSeperator(total_paid) }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Discount: <span class="text-danger">{{ thousandSeperator(total_discount) }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Balance: <span class="text-danger">{{ thousandSeperator(total_balance) }}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!SalesAnalysis" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
